import type emailZh from '../zh/email';

const email: typeof emailZh = {
  load_failed: 'Tải hội thoại email thất bại',
  stats_load_failed: 'Không tải được thống kê email',
  thread_load_failed: 'Tải email thất bại',
  copied: 'Đã sao chép {{address}}',
  platform_fallback: 'Email nền tảng: {{address}}',
  synced: 'Đã đồng bộ {{count}} KOL Wowbit có email',
  marked_read: 'Đã đánh dấu đã đọc',
  mark_read_failed: 'Không đánh dấu được đã đọc',
  talent_detail: 'Xem chi tiết KOL',
  unread_count: 'Chưa đọc {{count}}',
  sent_count: 'Đã gửi {{count}}',
  received_count: 'Đã nhận {{count}}',
  opened_count: 'Đã mở {{count}}',
  intent_talent: 'KOL quan tâm',
  bounced: 'Thư trả lại',
  title: 'Email',
  platform_email: 'Email nền tảng',
  forward_hint: 'Thư trả lời được chuyển tiếp tới {{address}}',
  domain_hint: 'Thư trả lời của KOL vào hộp thư này, không đổi được tên miền gửi',
  sent_month: 'Đã gửi tháng này',
  quota_hint: '/ {{limit}} · Tỷ lệ gửi {{rate}}% · còn {{remain}}',
  unread: 'Chưa đọc',
  unread_threads: '{{count}} hội thoại KOL',
  pending: 'Chờ trả lời',
  pending_hint: 'KOL đã trả lời, chờ phía mình · KOL quan tâm {{count}}',
  pending_reply_hint: 'KOL đã trả lời, đang chờ phía mình',
  pending_reply_failed: 'Không tải được số email chờ trả lời',
  new_send: 'Soạn email mới',
  sync_talents: 'Đồng bộ KOL Wowbit có email',
  change_bind: 'Đổi email đã liên kết',
  bind_mine: 'Liên kết email của tôi',
  copy_platform: 'Sao chép email nền tảng',
  conversations: 'Hội thoại email KOL',
  sent_received: 'Đã gửi {{sent}} · Đã nhận {{received}}',
  no_match: 'Không có hội thoại phù hợp',
  empty_conversations: 'Chưa có hội thoại email',
  reply_placeholder: 'Trả lời {{name}}…',
  reply: 'Trả lời',
  reply_sent: 'Đã trả lời',
  reply_failed: 'Không gửi được thư trả lời',
  mark_read: 'Đánh dấu đã đọc',
  idle: 'Chọn KOL bên trái để xem thư',
  empty_thread: 'Chưa có thư trao đổi',
  opened: 'Đã mở',
  filter_all: 'Tất cả',
  status_WAITING_CREATOR: 'Chờ KOL',
  status_NEED_REPLY: 'Cần trả lời',
  status_PROCESSED: 'Đã xử lý',
  status_HARD_BOUNCE: 'Thư trả lại cứng',
  conversation_total: '{{total}} hội thoại',
  shop_required: 'Hãy chọn cửa hàng trước',
  search_placeholder: 'Tìm KOL / email',
  intent: 'Quan tâm',
  replied: 'Đã trả lời',
  follow_up: 'Cần theo dõi',
  tpl_sample: 'Hợp tác dùng thử sản phẩm mới',
  tpl_repurchase: 'Mời hợp tác mua lại',
  tpl_blank: 'Email trống',
  fill_subject: 'Vui lòng nhập tiêu đề và nội dung email',
  sent_skipped: 'Đã gửi {{sent}} thư, bỏ qua {{skipped}} người (không có email / thư trả lại)',
  sent_ok: 'Đã gửi {{sent}} email',
  send_failed: 'Gửi thất bại, vui lòng thử lại sau',
  recipients: 'Chọn KOL nhận',
  selected_skip: 'Đã chọn {{count}} KOL. KOL không có email hoặc thư bị trả lại sẽ được bỏ qua',
  invalid_address: 'Vui lòng nhập địa chỉ email hợp lệ',
  bound: 'Đã liên kết {{address}}. Thư trả lời của KOL sẽ được chuyển tiếp tới email này',
  bind: 'Liên kết',
  bind_hint:
    'Sau khi liên kết, thư trả lời của KOL được chuyển tiếp tới email này. Gửi thư vẫn dùng email nền tảng để đảm bảo tỷ lệ gửi và gom thư trả lời.',
  blocked_bounced: 'Email này đã bị trả lại (không liên lạc được). Hãy cập nhật email KOL trước khi gửi',
  blocked_quota: 'Đã dùng hết hạn mức gửi thư tháng này ({{limit}} thư)'
};

export default email;
